module.exports = __webpack_public_path__ + "img/myanmar-flag.84e873c3.png";